export default __webpack_public_path__ + "static/media/how-it-works--tablet.cb48b664.webp";